import { ErrorType } from '../../apis/api';
import { addToast } from '@ydistri/utils';
import { Dispatch } from 'redux';

export const processErrorAndShowToast =
  (dispatch: Dispatch, prefix: string) =>
  (err: unknown): void => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- we know the type
    const error = err as ErrorType;
    dispatch(
      addToast({
        message: `${prefix}: ${error.response.data.Messages.join(', ')}`,
        isError: true,
      }),
    );
  };
